import axios from "axios";
const url = process.env.REACT_APP_CREATE_LEAD_URL;

export async function createLead(authToken, urn, payload){
    try{
        const response = await axios.post(
            url,
            payload,
            {
                headers: {
                    "authToken": authToken,
                    "urn":urn,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    }
    catch(error){
        console.log(error);
    }
   
}